import { render, staticRenderFns } from "./AccountBook.vue?vue&type=template&id=0647f1f2&scoped=true&"
import script from "./AccountBook.vue?vue&type=script&lang=js&"
export * from "./AccountBook.vue?vue&type=script&lang=js&"
import style0 from "./AccountBook.vue?vue&type=style&index=0&id=0647f1f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647f1f2",
  null
  
)

export default component.exports